module.exports = __webpack_public_path__ + "img/boatmax20.ec8d95ce.png";